
{
    document.o2.script = {};
    let scripts = document.o2.script;
    let _o2 = document.o2;
    let last_mouse_down = Date.now();
    _o2.dist_appear = false;
    scripts["init"] = function init() {
        _o2.switch_camera2(-292, -4684, -242, 15099, 16853, 16262);
        _o2.time_pass = 0;
        let obj = _o2.search_obj_by_name("底图");
        if (obj) obj.visible = false;
        obj = _o2.search_obj_by_name("底图1");
        if (obj) { obj.visible = false; _o2.mtl1 = obj.material; }
        obj = _o2.search_obj_by_name("底图2");
        if (obj) { obj.visible = false; _o2.mtl2 = obj.material; }
        obj = _o2.search_obj_by_name("底图3");
        if (obj) { obj.visible = false; _o2.mtl3 = obj.material; }
        obj = _o2.search_obj_by_name("底图4");
        if (obj) { obj.visible = false; _o2.mtl4 = obj.material; }
        obj = _o2.search_obj_by_name("manyou");
        if (obj) obj.visible = false;
        _o2.current_flash = null;
        let ani = _o2.animation.get_timeline_by_name("car");
        if (ani) {
            ani.play();
        }
        _o2.bmap = false;
        _o2.bmanyou = false;
        _o2.mtls = [];
        for (let i = 1; i <= 11; i++) {
            let name = "f" + i;
            obj = _o2.search_obj_by_name(name);
            if (obj) {
                _o2.mtls.push(obj.material);
            }
        }
        _o2.bds = [];
        obj = _o2.search_obj_by_name("高层A");
        if (obj) _o2.bds.push(obj);
        obj = _o2.search_obj_by_name("高层B");
        if (obj) _o2.bds.push(obj);
        obj = _o2.search_obj_by_name("高层C");
        if (obj) _o2.bds.push(obj);
        obj = _o2.search_obj_by_name("小高层D");
        if (obj) _o2.bds.push(obj);
        obj = _o2.search_obj_by_name("洋房E");
        if (obj) _o2.bds.push(obj);

        if (_o2.on_loading_msg) _o2.on_loading_msg("正在下载:", String(Math.ceil(100)), "%");
    }
    _o2.switch_zhoubian = function switch_zhoubian(name) {
        let obj = _o2.search_obj_by_name(name);
        if (_o2.last_zhoubian)
        {
            _o2.last_zhoubian.visible=false;
        }
        if (obj)
        {
            _o2.last_zhoubian=obj;
            obj.visible=true;
        }
    }
    _o2.to_map = function to_map() {
        if (_o2.bmap) return;
        _o2.bmap = true;

        _o2.switch_camera2(-9920,-4684,-10338,-10863,98646,135129);
        let obj = _o2.search_obj_by_name("底图");
        if (obj) obj.visible = true;

        let ani = _o2.animation.get_timeline_by_name("to_map");
        if (ani) {
            ani.current_time = 0;
            ani.play();
        }
    }

    _o2.hide_manyou = function hide_manyou() {
        if (!_o2.bmanyou) {
            return;
        }
        _o2.bmanyou = false;
        {

            let ani = _o2.animation.get_timeline_by_name("manyou");
            if (ani) {
                ani.bPlaying = false;
            }
            _o2.manyou.visible = false;
        }
    }
    _o2.show_manyou = function manyou() {
        if (_o2.bmanyou) {
            return;
        }
        _o2.bmanyou = true;
        {
            let obj = _o2.search_obj_by_name("manyou");
            if (obj) { obj.visible = true; _o2.manyou = obj; }
            let ani = _o2.animation.get_timeline_by_name("manyou");
            if (ani) {
                ani.play();
            }
        }
    }
    _o2.to_3d = function to_3d() {
        if (!_o2.bmap) return;
        _o2.switch_zhoubian("");
        _o2.bmap = false;
        let obj = _o2.search_obj_by_name("底图");
        if (obj) obj.visible = false;
        obj = _o2.search_obj_by_name("底图1");
        if (obj) { obj.visible = false; }
        obj = _o2.search_obj_by_name("底图2");
        if (obj) { obj.visible = false; }
        obj = _o2.search_obj_by_name("底图3");
        if (obj) { obj.visible = false; }
        obj = _o2.search_obj_by_name("底图4");
        if (obj) { obj.visible = false; }
        _o2.switch_camera2(-292, -4684, -242, 15099, 16853, 16262);
    }
    _o2.switch_building = function switch_building(name) {
        if (_o2.now_building) {
            _o2.now_building.visible = false;
        }
        let obj = _o2.search_obj_by_name(name);
        if (obj) {
            _o2.now_building = obj;
            obj.visible = true;
        }
    }
    scripts["frame_move"] = function frame_move(time_passed) {
        _o2.time_pass += time_passed;
        if (_o2.time_pass > 2) {
            _o2.time_pass = 0;
        }
        let alpha = Math.abs(_o2.time_pass - 1);
        if (_o2.last_zhoubian)
        {
            for (let i=0;i<_o2.last_zhoubian.children.length;i++)
            {
                _o2.last_zhoubian.children[i].material.opacity=alpha/2;
            }
        }
        if (_o2.mtls) {
            for (let i = 0; i < _o2.mtls.length; i++) {
                let mtl = _o2.mtls[i];
                mtl.opacity = alpha;
            }
        }
    }

    scripts["timeline"] = function timeline(x, y) {
        console.log(x);
        console.log(y);
        if (y.name == "ditu") {
            {
                let obj = _o2.search_obj_by_name("底图1");
                if (obj) obj.visible = true;
                obj = _o2.search_obj_by_name("底图2");
                if (obj) obj.visible = true;
                obj = _o2.search_obj_by_name("底图3");
                if (obj) obj.visible = true;
                obj = _o2.search_obj_by_name("底图4");
                if (obj) obj.visible = true;
                _o2.switch_camera2(-9920, -4684, -10338, -9920, 444530, -10338);
            }
        }
    }
    console.log(document.o2.script);

    function onDocumentClick2(event){
        let time2 = Date.now();
        if (time2-last_mouse_down>100)
        {
            return;
        }
        event.preventDefault();
        let intersects = _o2.ray_test(event);
        if (intersects.length > 0) {
            console.log(intersects[0].object.name);
            let object = intersects[0].object;
            let str = Math.round(_o2.cameraControls.target.x)+","+Math.round(_o2.cameraControls.target.y)+","+Math.round(_o2.cameraControls.target.z)+",";
            str=str+Math.round(_o2.camera.position.x)+","+Math.round(_o2.camera.position.y)+","+Math.round(_o2.camera.position.z);
            console.log(str);
        }else{
        }
    }
    function onMouseDown(event) {
        last_mouse_down = Date.now();
    }

    var idx = 1;
    var touch_time;
    var last_tap_time;
    function touch_start(event) {
        touch_time = Date.now();
    }
    function db_clicked(event) {
        console.log('111')
        let objects = [];
        for (let i = 0; i < _o2.bds.length; i++) {
            if (_o2.bds[i].visible) {
                objects.push(_o2.bds[i]);
            }
        }
        let intersects = _o2.ray_test2(objects, event);
        if (intersects.length > 0) {
            console.log(intersects[0].object.name);
            let object = intersects[0].object;
            // let str = Math.round(_o2.cameraControls.target.x)+","+Math.round(_o2.cameraControls.target.y)+","+Math.round(_o2.cameraControls.target.z)+",";
            // str=str+Math.round(_o2.camera.position.x)+","+Math.round(_o2.camera.position.y)+","+Math.round(_o2.camera.position.z);
            // console.log(str);
            if (object.parent) {

                document.Bus.$emit("户型", object.parent.name)

            }
        }
    }
    function touch_end(event) {
        let dnow = Date.now();
        let dst = dnow - touch_time;
        if (dst < 100) {
            console.log("touch_click");
            event.preventDefault();
            event.offsetX = event.changedTouches[0].clientX;
            event.offsetY = event.changedTouches[0].clientY;
            db_clicked(event);
        }
        touch_time = Date.now();
    }
    _o2.container.addEventListener("touchstart", touch_start, false);
    _o2.container.addEventListener("touchend", touch_end, false);

    function onDocumentClick(event) {
        let time2 = Date.now();
        if (time2 - last_mouse_down > 100) {
            return;
        }
        event.preventDefault();
        db_clicked(event);
    }
    function onMouseDown(event) {
        last_mouse_down = Date.now();
    }
    _o2.container.addEventListener('click', onDocumentClick, false);
    _o2.container.addEventListener('pointerdown', onMouseDown, false);
}